export default __webpack_public_path__ + "static/media/krilnekapije4.541a68d6.png";